import type { CallConversation } from "@/playground/components/DevHome/table/graphql/types";
import { formatInternational } from "@/playground/components/DevHome/table/utilities/phone_number/phone_number.utility";
import type { CustomerRowType } from "../../../pages/conversation_center/components/Table/Table.decl";

export const getCustomer = (
  contacts: CallConversation["contacts"]
): CustomerRowType[] =>
  (contacts ?? []).flatMap((contact) => {
    if (!contact) {
      return [];
    }

    // The API can return an anonymous contact.
    if (contact.phoneNumber === "anonymous") {
      return [
        {
          phoneNumber: "",
          displayName: "Anonymous",
        },
      ];
    }

    if (contact.external.entity.__typename === "ExternalNumber") {
      const { phoneNumber } = contact.external.entity;
      const formattedNumber = formatInternational(phoneNumber);

      return [
        {
          phoneNumber: formattedNumber,
          displayName: formattedNumber,
        },
      ];
    }

    if (contact.external.entity.__typename === "PhoneContact") {
      const { mainPhoneNumber } = contact.external.entity;
      const { fullName } = contact.external.entity;

      const formattedNumber = formatInternational(mainPhoneNumber);

      return [
        {
          fullName: fullName.trim(),
          phoneNumber: formattedNumber,
          displayName: fullName.trim() || formattedNumber,
        },
      ];
    }

    return [];
  });
